import { ConsoleLog } from "@inntechcorp/it-design";
import { ErrorDetailProps, usePostFetch } from "Api/hooks/usePostFetch";
import { AxiosProgressEvent } from "axios";

export type FetchTypeProps = {
  apiPath   : string,
  params?   : object,
  queries?  : object,
  headers?  : object,
  type?     : "post" | "get" | "put" | "update",
  success?  : (result: any) => void,
  error?    : (error?:ErrorDetailProps) => void,
  progress? : (event:AxiosProgressEvent) => void,
}

/**
 * 
 * useAPI
 * ---
 * 
 * @description Ekstra özellik gerektirmeyen api çağırmaları için
 * kullanılır. API sorgusu yapmak için `_fetch`, yapılan sorguyu
 * iptal etmek için `_cancel` çağrılır.
 * 
 */
export default function useAPI(changeLogout?:(status:string) => void, isLoggedOut?:boolean) {

  const { fetch, cancel }   = changeLogout && isLoggedOut 
                              ? usePostFetch()
                              : usePostFetch(changeLogout, isLoggedOut);

  const onError = (detail?:ErrorDetailProps) => {
    ConsoleLog.double("🔴 Inn.tech Web Error [useAPI] Unhandled Exception", detail?.detail, "error");
    detail && console.error(detail);
  }

  /**
   * 
   * CANCEL
   * ---
   * 
   * @description API sorgunu iptal eder.
   * 
   */
  const _cancel = () => {
    cancel();
  };

  /**
   * 
   * FETCH
   * ---
   * 
   * @description API sorgusunu iletilen değerlerle birlikte başlatır. Bu sorgu
   * istenildiği taktirde `_cancel` çağrılarak iptal edilebilir.
   * 
   * @param params    API sorgusuna eklenecek param değerleri objesi.
   * @param queries   API sorgusuna eklenecek query değerleri objesi.
   * @param headers   API sorgusuna eklenecek header değerleri objesi.
   * @param apiPath   API sorgusunun yapılacak adres.
   * @param success   API sorgusu başarıyla tamamlandığında çağrılır.
   * @param error     API sorgusu iptal edildiğinde çağrılır.
   * 
   */
  const _fetch = async ({
    params    = {},
    queries   = {},
    headers   = {},
    apiPath   = "",
    type      = "post",
    success,
    error,
    progress
  }:FetchTypeProps) => {

    await fetch(
      type ? type : "post",
      apiPath,
      params,
      {
        onFetched   : success,
        onError     : error ? error : onError,
        onProgress  : progress
      },
      queries,
      headers
    );

  };

  return { _fetch, _cancel };
}
